/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 04:20 pm
 * Last Modified: Tuesday, 24-08-27 11:34 am, by Roger
 */

import { StyledComponent } from '@emotion/styled';

import {
  Box,
  BoxProps,
  Button,
  ButtonProps,
  dialogClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { Flex } from '@/containers';

import { BaseDialog, BaseDialogProps } from '../../components/BaseDialog';

export const StyledDialog: StyledComponent<BaseDialogProps> = styled(
  BaseDialog
)(() => ({
  [`.${dialogClasses.paper}`]: {
    padding: '30px 20px 20px',
    width: '320px',
  },
}));

export const StyledFlex: StyledComponent<BoxProps> = styled(Flex)`
  flex-direction: column;
`;
export const StyledTitle: StyledComponent<BoxProps> = styled(Box)`
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
`;

export const StyledContent: StyledComponent<BoxProps> = styled(Box)({
  textAlign: 'center',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '24px',
  color: '#848E9C',
});

export const StyledButton: StyledComponent<ButtonProps> = styled(Button)`
  flex: 1;
`;
